import { useAppSelector } from '@online-webinar/store';
import { useTranslation } from 'react-i18next';

export const OnlineViewersCount = () => {
    const { t } = useTranslation();
    const totalViewers = useAppSelector((state) => state.liveWebinar.onlineParticipants);

    return (
        <div className="flex justify-center gap-2">
            <div className="flex flex-col">
                <span className="text-3xl">{totalViewers}</span>
                {t('Broadcaster.Dialog.TooEarly.OnlineViewersText')}
            </div>
        </div>
    );
};
